<template>
  <button :class="classBtn" @click="clickBtn">{{textBtn}}</button>
</template>

<script>
export default {
  name: 'buttonComp',
  props: {
    textBtn: String,
    classBtn: String,
    clickBtn: Function
  }
}
</script>

<style scoped lang="scss">
.btn_orange{
  width: 100%;
  height: 53px;
  object-fit: contain;
  border-radius: 9px;
  background-color: #ff8200;
  object-fit: contain;
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  color: #ffffff;
};

.btn_white{
  width: 160px;
  height: 42px;
  object-fit: contain;
  border-radius: 9px;
  background-color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: #ff8200;
};

.btn_orange_min {
  margin: 0;
  object-fit: contain;
  border-radius: 9px;
  background-color: #ff8200;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  padding-left: 10px;
  padding-right: 10px;
  color: #ffffff;
  width: 100%;
  height: 32px;
}

.btn_white_min {
  margin: 0;
  object-fit: contain;
  border-radius: 9px;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  padding: auto;
  color: #ff8200;
  width: 100%;
  height: 28px;
}

button:active, button:hover {
  opacity: 0.5;
  cursor: pointer;
}
</style>
